import { render, staticRenderFns } from "./makersview.vue?vue&type=template&id=71acac4d&scoped=true"
import script from "./makersview.vue?vue&type=script&lang=js"
export * from "./makersview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71acac4d",
  null
  
)

export default component.exports